import { RESET } from '../redux/game'
import { LOGOUT } from '../redux/auth'
import { updateDeviceMaster } from '../redux/device'
import adminApi from '../services/admin-api'
import api from '../services/api'
import wait from '../lib/wait'

// Actions
const FETCH_PARTICIPANTS_START = 'ascension/participants/fetching'
const FETCH_PARTICIPANTS_SUCCESS = 'ascension/participants/success'
const FETCH_PARTICIPANTS_ERROR = 'ascension/participants/error'

const CEO_TRANSFER_REQUEST_START = 'ascension/ceotransferrequest/fetching'
const CEO_TRANSFER_REQUEST_SUCCESS = 'ascension/ceotransferrequest/success'
const CEO_TRANSFER_REQUEST_ERROR = 'ascension/ceotransferrequest/error'

const SET_CEO_TRANSFER_REQUEST_RECEIVED = 'ascension/ceotransferrequestreceived/set'
const SET_CEO_TRANSFER_REQUEST_PENDING = 'ascension/ceotransferrequestpending/set'

const ACCEPT_CEO_TRANSFER_REQUEST_START = 'ascension/acceptceotransferrequest/fetching'
const DECLINE_CEO_TRANSFER_REQUEST_START = 'ascension/declineceotransferrequest/fetching'
const ACCEPT_DECLINE_CEO_TRANSFER_REQUEST_SUCCESS = 'ascension/acceptdeclineceotransferrequest/success'
const ACCEPT_DECLINE_CEO_TRANSFER_REQUEST_ERROR = 'ascension/acceptdeclineceotransferrequest/error'

const CEO_TRANSFER_REQUEST_STATUS_START = 'ascension/ceotransferrequeststatus/fetching'
const CEO_TRANSFER_REQUEST_STATUS_SUCCESS = 'ascension/ceotransferrequeststatus/success'
const CEO_TRANSFER_REQUEST_STATUS_ERROR = 'ascension/ceotransferrequeststatus/error'

const CANCEL_CEO_TRANSFER_REQUEST_START = 'ascension/cancelceotransferrequest/fetching'
const CANCEL_CEO_TRANSFER_REQUEST_SUCCESS = 'ascension/cancelceotransferrequest/success'
const CANCEL_CEO_TRANSFER_REQUEST_ERROR = 'ascension/cancelceotransferrequest/error'

const CLEAR_CEO_TRANSFER_DATA = 'ascension/clearceotransferdata'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  participants: [],

  ceoTransferRequestInProgress: false,
  ceoTransferRequestComplete: false,
  ceoTransferRequestError: null,

  ceoTransferRequestReceived: null,

  ceoTransferRequestId: null,

  ceoTransferRequestParticipantId: null,

  acceptCeoTransferRequestInProgress: false,
  declineCeoTransferRequestInProgress: false,
  acceptDeclineCeoTransferRequestComplete: false,
  acceptDeclineCeoTransferRequestError: null,

  ceoTransferRequestStatusInProgress: false,
  ceoTransferRequestStatus: null,
  ceoTransferRequestStatusError: null,

  cancelCeoTransferRequestInProgress: false,
  cancelCeoTransferRequest: null,
  cancelCeoTransferRequestError: null
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CLEAR_CEO_TRANSFER_DATA: {
      return initialState
    }
    case SET_CEO_TRANSFER_REQUEST_PENDING: {
      return {
        ...state,
        ceoTransferRequestParticipantId: action.data.to,
        ceoTransferRequestInProgress: true,
        ceoTransferRequestComplete: true,
        ceoTransferRequestId: action.data.id,
        ceoTransferRequestStatusInProgress: true,
        ceoTransferRequestStatus: null,
        ceoTransferRequestStatusError: null
      }
    }
    case FETCH_PARTICIPANTS_START: {
      return {
        ...state,
        isLoading: true,
        error: null
      }
    }
    case FETCH_PARTICIPANTS_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        error: null,
        participants: action.data
      }
    }
    case FETCH_PARTICIPANTS_ERROR: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        error: action.data
      }
    }
    case CEO_TRANSFER_REQUEST_START: {
      return {
        ...state,
        ceoTransferRequestInProgress: true,
        ceoTransferRequestError: null,
        ceoTransferRequestStatusInProgress: false,
        ceoTransferRequestStatus: null,
        ceoTransferRequestStatusError: null
      }
    }
    case CEO_TRANSFER_REQUEST_SUCCESS: {
      return {
        ...state,
        ceoTransferRequestComplete: true,
        ceoTransferRequestInProgress: false,
        ceoTransferRequestError: null
      }
    }
    case CEO_TRANSFER_REQUEST_ERROR: {
      return {
        ...state,
        ceoTransferRequestComplete: false,
        ceoTransferRequestInProgress: false,
        ceoTransferRequestError: action.data
      }
    }
    case SET_CEO_TRANSFER_REQUEST_RECEIVED: {
      return {
        ...state,
        ceoTransferRequestReceived: action.data
      }
    }
    case ACCEPT_CEO_TRANSFER_REQUEST_START: {
      return {
        ...state,
        acceptCeoTransferRequestInProgress: true,
        declineCeoTransferRequestInProgress: false,
        acceptDeclineCeoTransferRequestError: null
      }
    }
    case DECLINE_CEO_TRANSFER_REQUEST_START: {
      return {
        ...state,
        acceptCeoTransferRequestInProgress: false,
        declineCeoTransferRequestInProgress: true,
        acceptDeclineCeoTransferRequestError: null
      }
    }
    case ACCEPT_DECLINE_CEO_TRANSFER_REQUEST_SUCCESS: {
      return {
        ...state,
        acceptDeclineCeoTransferRequestComplete: true,
        acceptCeoTransferRequestInProgress: false,
        declineCeoTransferRequestInProgress: false,
        acceptDeclineCeoTransferRequestError: null,
        ceoTransferRequestReceived: null,
        ceoTransferRequestId: null
      }
    }
    case ACCEPT_DECLINE_CEO_TRANSFER_REQUEST_ERROR: {
      return {
        ...state,
        acceptDeclineCeoTransferRequestComplete: false,
        acceptCeoTransferRequestInProgress: false,
        declineCeoTransferRequestInProgress: false,
        acceptDeclineCeoTransferRequestError: action.data
      }
    }
    case CEO_TRANSFER_REQUEST_STATUS_START: {
      return {
        ...state,
        ceoTransferRequestId: action.data,
        ceoTransferRequestStatusInProgress: true,
        ceoTransferRequestStatus: null,
        ceoTransferRequestStatusError: null
      }
    }
    case CEO_TRANSFER_REQUEST_STATUS_SUCCESS: {
      return {
        ...state,
        ceoTransferRequestStatusInProgress: false,
        ceoTransferRequestStatus: action.data,
        ceoTransferRequestStatusError: null
      }
    }
    case CEO_TRANSFER_REQUEST_STATUS_ERROR: {
      return {
        ...state,
        ceoTransferRequestStatusInProgress: false,
        ceoTransferRequestStatus: null,
        ceoTransferRequestStatusError: action.data
      }
    }
    case CANCEL_CEO_TRANSFER_REQUEST_START: {
      return {
        ...state,
        ceoTransferRequestStatusInProgress: false,
        ceoTransferRequestComplete: false,
        cancelCeoTransferRequestInProgress: true,
        cancelCeoTransferRequest: null,
        cancelCeoTransferRequestError: null
      }
    }
    case CANCEL_CEO_TRANSFER_REQUEST_SUCCESS: {
      return {
        ...state,
        cancelCeoTransferRequestInProgress: false,
        cancelCeoTransferRequest: action.data,
        cancelCeoTransferRequestError: null
      }
    }
    case CANCEL_CEO_TRANSFER_REQUEST_ERROR: {
      return {
        ...state,
        cancelCeoTransferRequestInProgress: false,
        cancelCeoTransferRequest: null,
        cancelCeoTransferRequestError: action.data
      }
    }
    case LOGOUT:
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

// Action Creators

export function clearCeoTransferData () {
  return {
    type: CLEAR_CEO_TRANSFER_DATA
  }
}

export function fetchParticipantsStart () {
  return {
    type: FETCH_PARTICIPANTS_START
  }
}

export function fetchParticipantsSuccess (data) {
  return {
    type: FETCH_PARTICIPANTS_SUCCESS,
    data
  }
}

export function fetchParticipantsError (error) {
  return {
    type: FETCH_PARTICIPANTS_ERROR,
    data: error
  }
}

export function fetchParticipants () {
  return async (dispatch, getState) => {
    dispatch(fetchParticipantsStart())
    const state = getState()

    const eventId = state.auth.eventId
    const environment = state.auth.environment
    const teamId = state.team.id

    try {
      const response = await adminApi.getParticipants({ environment, eventId, teamId })
      dispatch(fetchParticipantsSuccess(response))
    } catch (e) {
      dispatch(fetchParticipantsError(e))
    }
  }
}

export function ceoTransferRequestStart () {
  return {
    type: CEO_TRANSFER_REQUEST_START
  }
}

export function ceoTransferRequestSuccess (data) {
  return {
    type: CEO_TRANSFER_REQUEST_SUCCESS,
    data
  }
}

export function ceoTransferRequestError (error) {
  return {
    type: CEO_TRANSFER_REQUEST_ERROR,
    data: error
  }
}

export function createCEOTransferRequest ({ requestedDeviceId }) {
  return async (dispatch, getState) => {
    const { deviceId } = getState().device
    dispatch(ceoTransferRequestStart())

    try {
      const response = await api.createCEOTransferRequest(deviceId, requestedDeviceId)
      dispatch(ceoTransferRequestSuccess(response))
      dispatch(fetchCeoTransferRequestStatus(response.id))
    } catch (e) {
      dispatch(ceoTransferRequestError(e))
    }
  }
}

export function setCEOTransferRequestReceived (request) {
  return {
    type: SET_CEO_TRANSFER_REQUEST_RECEIVED,
    data: request
  }
}

export function setCEOTransferRequestPending (request) {
  return {
    type: SET_CEO_TRANSFER_REQUEST_PENDING,
    data: request
  }
}

export function acceptDeclineCeoTransferRequestStart (action) {
  return {
    type: action === 'accept' ? ACCEPT_CEO_TRANSFER_REQUEST_START : DECLINE_CEO_TRANSFER_REQUEST_START
  }
}

export function acceptDeclineCeoTransferRequestSuccess (data) {
  return {
    type: ACCEPT_DECLINE_CEO_TRANSFER_REQUEST_SUCCESS,
    data
  }
}

export function acceptDeclineCeoTransferRequestError (error) {
  return {
    type: ACCEPT_DECLINE_CEO_TRANSFER_REQUEST_ERROR,
    data: error
  }
}

export function acceptDeclineCEOTransferRequest (requestId, action) {
  return async (dispatch, getState) => {
    const { deviceId } = getState().device
    dispatch(acceptDeclineCeoTransferRequestStart(action))

    try {
      const response = await api.acceptDeclineCEOTransferRequest(deviceId, requestId, action)
      dispatch(acceptDeclineCeoTransferRequestSuccess(response))
      if (action === 'accept') {
        dispatch(updateDeviceMaster(true))
      }
    } catch (e) {
      dispatch(acceptDeclineCeoTransferRequestError(e))
    }
  }
}

export function fetchCeoTransferRequestStatusStart (requestId) {
  return {
    type: CEO_TRANSFER_REQUEST_STATUS_START,
    data: requestId
  }
}

export function fetchCeoTransferRequestStatusSuccess (data) {
  return {
    type: CEO_TRANSFER_REQUEST_STATUS_SUCCESS,
    data
  }
}

export function fetchCeoTransferRequestStatusError (error) {
  return {
    type: CEO_TRANSFER_REQUEST_STATUS_ERROR,
    data: error
  }
}

export function fetchCeoTransferRequestStatus (requestId) {
  return async (dispatch, getState) => {
    const { deviceId } = getState().device
    dispatch(fetchCeoTransferRequestStatusStart(requestId))

    try {
      let status = 'pending'
      while (status === 'pending' && getState().participants.ceoTransferRequestStatusInProgress) {
        await wait(1000)
        const response = await api.getCEOTransferRequest(deviceId, requestId)
        status = response.status
      }
      dispatch(fetchCeoTransferRequestStatusSuccess(status))
      if (status === 'accepted') {
        dispatch(updateDeviceMaster(false))
      }
    } catch (e) {
      dispatch(fetchCeoTransferRequestStatusError(e))
    }
  }
}

export function cancelCeoTransferRequestStart () {
  return {
    type: CANCEL_CEO_TRANSFER_REQUEST_START
  }
}

export function cancelCeoTransferRequestSuccess (data) {
  return {
    type: CANCEL_CEO_TRANSFER_REQUEST_SUCCESS,
    data
  }
}

export function cancelCeoTransferRequestError (error) {
  return {
    type: CANCEL_CEO_TRANSFER_REQUEST_ERROR,
    data: error
  }
}

export function cancelCeoTransferRequest () {
  return async (dispatch, getState) => {
    const { deviceId } = getState().device
    const { ceoTransferRequestId } = getState().participants
    dispatch(cancelCeoTransferRequestStart())

    try {
      const response = await api.cancelCEOTransferRequest(deviceId, ceoTransferRequestId)
      dispatch(cancelCeoTransferRequestSuccess(response))
    } catch (e) {
      dispatch(cancelCeoTransferRequestError(e))
    }
  }
}

export function checkCeoTransferPending (request) {
  return async (dispatch, getState) => {
    if (!request || getState().participants.ceoTransferRequestStatusInProgress) {
      return
    }
    dispatch(setCEOTransferRequestPending(request))
    dispatch(fetchCeoTransferRequestStatus(request.id))
  }
}
